import { useEffect } from 'react';
import { createPortal } from 'react-dom';
import type { Receipt } from '@/features/billing/types';
import { ReceiptBody } from './ReceiptBody';
import styles from './ReceiptPrintSheet.module.css';

/**
 * The receipt's own print root, a direct child of <body> like the MC and referral sheets. Its CSS hides the rest
 * of the page only while this root exists (RL-2192). `onDone` must be stable: it re-runs the print otherwise.
 */
export function ReceiptPrintSheet({
  receipt,
  onDone,
}: {
  receipt: Receipt;
  onDone: () => void;
}) {
  useEffect(() => {
    window.addEventListener('afterprint', onDone, { once: true });
    window.print();
    return () => window.removeEventListener('afterprint', onDone);
  }, [onDone]);

  return createPortal(
    <div
      className={styles.printRoot}
      data-receipt-print-root=""
      data-testid="receipt-print-sheet"
    >
      <ReceiptBody r={receipt} />
    </div>,
    document.body,
  );
}
